import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8a8c626e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "inventory-no-result" };
const _hoisted_2 = { key: 1 };
import ProgressSpinner from 'primevue/progressspinner';
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskInventoryNoResult',
    props: {
        loading: { type: Boolean }
    },
    setup(__props) {
        const { loading } = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.loading)
                    ? (_openBlock(), _createBlock(_unref(ProgressSpinner), {
                        key: 0,
                        style: { "width": "50px", "height": "50px" },
                        pt: {
                            spinner: { style: { animationDuration: '.5s' } },
                            circle: { style: { stroke: '#35C4DC', strokeWidth: 3, animation: 'none' } }
                        }
                    }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_2, "Oops ! No result, try again."))
            ]));
        };
    }
});
